(function () {
	const header = () => {
		const body = document.querySelector('body');
		const header = document.querySelector(".shopify-section-header");
		const openBtn = document.querySelector('.header__offcanvas-toggle');
		const closeBtn = document.querySelector(
			'.header__offcanvas-toggle-link--close',
		);
		const offMenu = document.querySelector('.header__offcanvas-menu');
		const searchDetails = document.querySelector('.header__details');
		const submenuDetails = document.querySelectorAll(
			'.header__submenu li details',
		);
		const openSearchBtn = document.querySelector('.header__search');

		const openMenu = (e) => {
			e.preventDefault();
			offMenu.classList.add('header__offcanvas-menu--open');
			openBtn.classList.add('active');
			body.classList.add('body--hidden');
		};

		const closeMenu = () => {
			offMenu.classList.remove('header__offcanvas-menu--open');
			openBtn.classList.remove('active');
			body.classList.remove('body--hidden');
		};


		submenuDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				submenuDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

		document.addEventListener('keyup', (e) => {
			if (e.key === 'Escape') {
				closeMenu();
				searchDetails.removeAttribute('open');
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove('overflow-hidden');
			}
		});

		openSearchBtn.addEventListener('click', () => {
			if (searchDetails.open) {
				body.classList.add('overflow-hidden');
				header.classList.add("shopify-section-header-sticky", "animate");
			} else {
				body.classList.remove('overflow-hidden');
				header.classList.remove("shopify-section-header-sticky", "animate");
			}
		});
	};

	document.addEventListener('shopify:section:load', header);

	header();
})();
